import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-password-dialog',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    MatProgressSpinnerModule
  ]
})
export class PasswordDialogComponent {
  password: string = '';
  path: string = '';
  loading: boolean = false;
  isHidden: boolean = false;
  title: string = ''

  constructor(
    public dialogRef: MatDialogRef<PasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { path: string, title: string }
  ) {
    if (data.path) {
      this.path = data.path;
      this.isHidden = true;
    }
    this.title = data.title || 'Enter Path & Password';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  submitPassword(): void {
    this.loading = true;
    const password = this.password;
    const path = this.path;
    this.dialogRef.close({ password, path });
  }
}
